import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Globe, Settings } from 'lucide-react';

interface HttpRequestNodeData {
  title?: string;
  url?: string;
  method?: string;
  responseVariable?: string;
  color?: string;
  tags?: string[];
}

export const HttpRequestNode = memo(({ data, isConnectable }: NodeProps<HttpRequestNodeData>) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-purple-200 hover:border-purple-400 transition-colors duration-300">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-purple-500"
      />
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Globe className="h-4 w-4 mr-2" style={{ color: data.color || '#8b5cf6' }} />
          <div className="text-sm font-medium text-gray-900">
            {data.title || 'Petición HTTP'}
          </div>
        </div>
        <Settings className="h-4 w-4 text-gray-400" />
      </div>
      <div className="mt-2 text-sm text-gray-600">
        <div className="flex items-center">
          <span className="px-1.5 py-0.5 bg-purple-100 text-purple-800 text-xs font-medium rounded mr-2">
            {data.method || 'GET'}
          </span>
          <span className="truncate">{data.url || 'Sin URL configurada'}</span>
        </div>
        {data.responseVariable && (
          <div className="mt-1 text-xs text-gray-500 flex items-center">
            <span>Variable: ${data.responseVariable}</span>
          </div>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="default"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-purple-500"
      />
    </div>
  );
});

HttpRequestNode.displayName = 'HttpRequestNode';